<template>
  <div>
    <div class="good-list-title">
      <div style="width:50px;text-align:left">&nbsp;</div>
      <div style="width:calc(100% - 50px - 80px);text-align:left">品名</div>
      <div style="width:80px;">订货数量</div>
    </div>
    <div class="good-list" style="height: calc(100vh - 100px - 90px );overflow-y: auto;">
        <div v-if="list.length<=0" style="padding-top:15vh;text-align: center;color:#999">
            <i class="icon iconzanwushuju2" style="font-size:60px"></i>
        </div>
        <van-cell-group v-for="(item,index) in details" :key="item.id">
          <div class="list-item" @click="selectItem(item)">
            <div class="tl-name" style="display:flex;padding:5px 0px">
              <div style="width:50px;text-align:center">
                <div>
                  <span decode="true" class="item-index" :style="{backgroundColor:showItem.goodsItemId==item.goodsItemId?'#4935ae':'#e0d5d5'}">{{index+1}}</span>
                </div>
                <div>
                  <van-icon name="arrow-up"  v-if="showItem.goodsItemId==item.goodsItemId"/>
                  <van-icon name="arrow-down" v-else/>
                </div>
              </div>
              <div style="width:calc(100% - 50px - 80px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border-bottom:1px solid #FFF" :style="{borderColor:showItem.goodsItemId==item.goodsItemId?'#EEE':'#FFF'}">
                  <div style="font-size:16px">{{item.name}}</div>
                  <div>
                    <span decode="true" style="color:#888;font-size:12px;">{{item.code?item.code:'-'}}&nbsp;&nbsp;(&nbsp;{{item.unit}}&nbsp;)&nbsp;&nbsp;{{item.goodsSpec?item.goodsSpec:'-'}}</span>
                  </div>
              </div>
              <div style="width:80px;border-bottom:1px solid #FFF" :style="{borderColor:showItem.goodsItemId==item.goodsItemId?'#EEE':'#FFF'}">
                <div class="good-list-price" style="text-align:center;margin-top: 10px;font-weight:600">{{item.purchaseCount?item.purchaseCount:0}}</div>
              </div>
            </div>
            <div style="padding-left:50px" v-if="showItem.goodsItemId==item.goodsItemId">
              <div style="display:flex;color:#888">
                <div style="flex:1">要货机构</div>
                <div style="width:80px">要货数量</div>
              </div>
              <div v-for="merchant in item.details" style="padding:5px 0px;display:flex">
                <div style="flex:1">{{merchant.merchantName}}</div>
                <div style="width:80px;text-align:center;font-weight:600">{{merchant.purchaseCount}}</div>
              </div>
            </div>
          </div>
        </van-cell-group>
        <div style="height:120px"></div>
    </div>
  </div>
</template>

<script>
export default {
  props:['details'],
    data() {
        return {
            hasBatch: false,
            showGoods: false,
            canceDel: 0,
            list: [{}],
            showEdit: false,
            selectGoods: {},
            settings: {},
            selectIndex: 0,
            showItem:{}
        }
    },
    methods:{
      selectItem(data){
        if(this.showItem.goodsItemId==data.goodsItemId){
          this.showItem={}
        }else{
          this.showItem=data
        }
      }
    }
}
</script>

<style>
.order-search{
  display: flex;
  padding: 5px 10px;
  height:50px;
  box-sizing: border-box;
  background-color: #FFF;
  align-items: center;
}
.order-search .search-input{
  width: calc(100% - 150px)
}
.order-search .search-input input{
  width: 100%;
  padding-left:5px;
  font-size: 14px;
  color:#888;
}
.order-search .search-icon{
  width: 150px;
  display: flex;
  height: 40px;
  box-sizing: border-box;
}
.order-search .search-icon .icon{
  font-size: 20px;
  color:#FFF;
}
.order-search .search-icon .icon-search{
  width: 75px;
  box-sizing: border-box;
  background-color: #486ad8;
  line-height: 40px;
  text-align: center;
}
.order-search .search-icon .icon-scan{
  width: 75px;
  color:#FFF;
  border-left: 1px solid #ccc;
  background-color: #486ad8;
  text-align: center;
  line-height: 40px;
  box-sizing: border-box;
}

.btns{
  display: flex;
  height: 50px;
  padding: 5px;
  line-height: 40px;
  box-sizing: border-box;
  background-color: #FFF;
}
.save{
  width: calc(50% - 10px);
  margin:0px 5px;
  text-align: center;
  
  font-size: 15px;
  background-color: #787CD2;
  color: #FFF;
}
.code{
  width: calc(50% - 10px);
  margin:0px 5px;
  font-size: 15px;
  text-align: center;
  background-color: #00B26A;
  color: #FFF;
}

.good-list-title{
  display:flex;
  border-bottom:1px solid #eee;
  font-size:15px;
  color:#333;
  height: 40px;
  line-height: 40px;
}
.good-list{
  /* padding:0rpx 10rpx; */
  font-size: 14px;
}
.good-list .good-item{
  display: flex;
  background-color:#FFF;
  margin-bottom: 5px;
  border-bottom: 1px solid #efefef;
  height: 30px;
  line-height: 30px;
}.good-list .list-item .item-index{
  background-color: #4935ae;
  color:#FFF;
  border-radius: 50%;
  display: inline-block;
  font-size: 12px;
  width: 23px;
  height: 23px;
  line-height: 23px;
  text-align: center;
}.good-list .list-item{
  margin-bottom: 5px;
  background-color: #FFF;
  color:#333;
  padding:10rpx 0rpx;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
}
.good-list .list-item .item-index text{
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: #486ad8;
  color: #FFF;
  text-align: center;
}
.good-list-price{
  text-align:left;
  font-size:14px;
  color:#4935ae;
}
.good-list .good-item .item-select{
  display: flex;
  justify-content: center;
  align-items: center;
  zoom: 0.8;
}
.good-item-detail{
  display: flex;
  align-items: center;
  background-color: #FFF;
  margin:5px;
}
.good-item-detail .item-select{
  width:40px;
  zoom: 0.8;
  text-align: center;
} 
.good-item-detail .item-box{
  width: calc(100% - 40px);
}
.good-item-detail .item-box .box-name{
  font-size:14px;
  color: #666;
  padding: 5px;
}
.good-item-detail .item-box .box-ck{
  display: flex;
  padding: 5px;
}
.good-item-detail .item-box .box-ck .box-code{
  width: 100px;
  font-size: 12px;
}
.good-item-detail .item-box .box-ck .box-keycode{
  width: calc(100% - 100px);
  font-size: 12px;
}
.good-list .good-item .text-center{
  font-size: 12px;
}
.good-list .good-item .row-cell{
  display: flex;
  height:25px;
  align-items: center;
  font-size: 12px;
}
.good-list .good-item .row-cell .item-left{
  flex:1;
      overflow: hidden;
  /*自动隐藏文字*/
  text-overflow: ellipsis;
  /*文字隐藏后添加省略号*/
  white-space: nowrap;
  /*强制不换行*/
}
.good-list .good-item .row-cell .item-right{
  flex:1;
  overflow: hidden;
  /*自动隐藏文字*/
  text-overflow: ellipsis;
  /*文字隐藏后添加省略号*/
  white-space: nowrap;
}
.good-list .good-item .row-cell .endNum{
      background-color: #2196f3;
      color: #FFF;
      padding: 5px 10px;
      border-radius: 50px;
}
.order-price{
  color:#F56C6C;
  font-weight: 600
}
</style>


// WEBPACK FOOTER //
// src/views/purchaseOrder/detailsTableFocus.vue